<template>
    <div class="view-tabs"
        :class="{ 'icon-only-mobile': iconOnlyMobile, 'view-tabs--underline': underline, 'view-tabs--start': underline && noGrow }">
        <button
            v-for="(op, i) in options" :key="i"
            class="view-tab"
            :class="{ active: op.value === option, locked: isLocked(op) }"
            @click="onClickOption(op)">
            <v-icon v-if="!underline" size="16" v-text="op.icon"/>
            <span>{{ op.name }}</span>
            <v-icon v-if="isLocked(op)" size="13">mdi-lock-outline</v-icon>
        </button>
    </div>
</template>

<script>
export default {
    name: "SelectOptionStudents",
    props: {
        noList: {
            type: Boolean,
            default: false,
        },
        onlyGroups: {
            type: Boolean,
            default: false,
        },
        iconOnlyMobile: {
            type: Boolean,
            default: false,
        },
        underline: {
            type: Boolean,
            default: false,
        },
        noGrow: {
            type: Boolean,
            default: false,
        },
        customOptions: {
            type: Array,
            default: null
        },
        features: {
            type: Object,
            default: () => ({})
        },
        value: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            option: null,
        }
    },
    computed: {
        options(vm = this) {
            if (vm.customOptions) return vm.customOptions
            let options = [
                {name: `${vm.$t('common.group')}s`, value: 'group', icon: 'mdi-account-multiple'},
                {name: `${vm.$t('common.team')}s`, value: 'team', icon: 'mdi-account-group'},
            ]
            if (vm.onlyGroups) return options
            options = [
                {name: vm.$t('common.list'), value: 'all', icon: 'mdi-group'},
                {name: `${vm.$t('common.student')}s`, value: 'student', icon: 'mdi-account'},
                ...options
            ]
            if (vm.noList) options = options.filter(option => option.value !== 'all')
            return options
        }
    },
    mounted() {
        const vm = this
        vm.setDefaults()
    },
    methods: {
        setDefaults() {
            const vm = this;
            vm.option = vm.value ? vm.value : vm.options[0].value
        },
        featureOf(op) {
            return op.feature || this.features[op.value] || null
        },
        isLocked(op) {
            const feature = this.featureOf(op)
            return !!feature && !this.can(feature)
        },
        onClickOption(op) {
            const vm = this
            if (vm.isLocked(op)) return vm.requirePlan(vm.featureOf(op))
            vm.option = op.value
        }
    },
    watch: {
        option(val) {
            this.$emit('change', val)
        },
        value() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>
.view-tabs {
    display: inline-flex;
    gap: 2px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 9px;
    padding: 3px;
    width: fit-content;
}

.view-tab {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 7px 16px;
    border-radius: 7px;
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    cursor: pointer;
    background: transparent;
    transition: all 0.15s;
}

.view-tab .v-icon {
    color: inherit;
}

.view-tab:not(.active):hover {
    color: var(--v-txtPrimary-base);
}

.view-tab.locked {
    color: var(--v-txtMuted-base);
}

.theme--dark .view-tab.active {
    background: rgba(204, 255, 51, 0.12);
    color: var(--v-primary-base);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.theme--light .view-tab.active {
    background: rgba(51, 153, 153, 0.12);
    color: var(--v-accent-base);
}

.view-tabs--underline {
    display: flex;
    width: 100%;
    gap: 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid var(--v-outline-base);
    border-radius: 0;
    padding: 0;
    padding-bottom: 1px;
}

.view-tabs--underline .view-tab {
    flex: 1;
    justify-content: center;
    padding: 10px 4px;
    border-radius: 0;
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
}

.view-tabs--underline .view-tab.active {
    background: transparent !important;
    box-shadow: none;
    color: var(--v-txtPrimary-base);
    border-bottom-color: var(--v-primary-base);
}

.theme--light .view-tabs--underline .view-tab.active {
    background: transparent !important;
    border-bottom-color: var(--v-accent-base);
}

.view-tabs--underline.view-tabs--start {
    width: auto;
    display: inline-flex;
    border-bottom: none;
}

.view-tabs--underline.view-tabs--start .view-tab {
    flex: 0 0 auto;
    padding: 10px 20px;
}

@media (max-width: 600px) {
    .view-tabs.icon-only-mobile {
        display: flex;
        width: 100%;
    }

    .view-tabs.icon-only-mobile .view-tab {
        flex: 0 0 auto;
        padding: 7px 14px;
    }

    .view-tabs.icon-only-mobile .view-tab.active {
        flex: 1 1 auto;
        justify-content: center;
    }

    .view-tabs.icon-only-mobile .view-tab:not(.active) span {
        display: none;
    }
}
</style>
